import { UserInfo } from '@microsoft/teamsfx';

import { handleGlobalError, handleUnhandledPromiseError } from 'src/errors';

export class Logger {
  private teamUser: UserInfo | undefined;

  constructor() {
    this.setupGlobalErrorHandlers();
  }

  getTeamUser = (): UserInfo | undefined => {
    return this.teamUser;
  };

  // Set user properties after authentication
  updateUser = (user: UserInfo): void => {
    if (user) {
      this.teamUser = user;
    }
  };

  private setupGlobalErrorHandlers(): void {
    window.onerror = (message, source, lineno, colno, error) => {
      handleGlobalError(message, source, lineno, colno, error, this.getTeamUser());
    };

    window.onunhandledrejection = (event) => {
      handleUnhandledPromiseError(event, this.getTeamUser());
    };
  }
}

export const logger = new Logger();
